import { render, staticRenderFns } from "./ResolDeltaSolMx_3_1d00.vue?vue&type=template&id=07276fe9&"
import script from "./ResolDeltaSolMx_3_1d00.vue?vue&type=script&lang=js&"
export * from "./ResolDeltaSolMx_3_1d00.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports